import styled from 'styled-components';

const TableContainer = styled.div`
  margin-bottom: ${(props) => props.marginBottom || '0'};
  margin-top: ${(props) => props.marginTop || '0'};
  
  .title-table {
    width: 100%;
    height: 24px;
    background: #ebf1fc;
    padding: 4px 0 4px 8px;
    color: #5e5e5e;
    font-family: Roboto;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }

  .container-table {
    padding: ${(props) => props.padding || '8px 0 0 20px'};
  }

  .table-header {
    th {
      /* padding: 8px; */
    }
  }
`;

export const CustomTable = ({ children, configTable = {} }) => {
  const { title = '', marginBottom = '' , marginTop = '', padding = ''} = configTable;

  return (
    <TableContainer marginBottom={marginBottom} marginTop={marginTop} padding={padding}>
      {title &&(
        <div className="title-table">{title}</div>
      )}
      <div className="container-table">
        {children}
      </div>
    </TableContainer>
  );
};
